import api from "../../../api/comptabilite/_operations";

export default {
    selectOperationsCaisse(data) {
        return new Promise((resolve, reject) => {
            api.getOperationsCaisse(data).then((response) => {
                resolve(response);
            },(error) => {
                    reject(error);
            });
        });
    },

    getListeFactures(data) {
        return new Promise((resolve, reject) => {
            api.getListeFacture(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeTicketCaisse(data) {
        return new Promise((resolve, reject) => {
            api.getListeTicketCaisse(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeOperationsPatient(data) {
        return new Promise((resolve, reject) => {
            api.getListeOperationsPatient(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeProduitsCreances(data) {
        return new Promise((resolve, reject) => {
            api.getListeProduitsCreances(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeChargesExploitation(data) {
        return new Promise((resolve, reject) => {
            api.getListeChargesExploitation(data).then((response) => {
                resolve(response);
            },(error) => {
                reject(error);
            });
        });
    },

    getListeCoupons(data) {
        return new Promise((resolve, reject) => {
            api.getListeCoupons(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeDemandeAnnulation(data) {
        return new Promise((resolve, reject) => {
            api.getListeDemandeAnnulation(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getJournalTresorier(data) {
        return new Promise((resolve, reject) => {
            api.getJournalTresorier(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },

    getListeReliquats(data) {
        return new Promise((resolve, reject) => {
            api.getListeReliquats(data).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },
}